import { useEffect, useState } from "react";
import { getParentCategories } from "../utils/userManual";

const useUserManual = baseURL => {
  const [data, setData] = useState({
    topics: [],
    categories: [],
    parentCategories: []
  });

  useEffect(() => {
    baseURL &&
      fetch(baseURL)
        .then(res => res.json())
        .then(data => {
          const { topics, categories } = data;
          const parentCategories = getParentCategories(categories);
          setData({
            topics,
            categories,
            parentCategories
          });
        })
        .catch(err => console.error("Fetching manifest.json failed", err));
  }, [baseURL]);

  return { ...data };
};

export default useUserManual;
